<template>
  <GenericList api-endpoint="data" ref="GenericList">
    <template v-slot:title>{{ $t('informationModuleList') }}</template>
    <template v-slot:header>
      <DataHeader />
    </template>
    <template v-slot:item="{ item, index }">
      <DataItem :item="item" :index="index" @remove-item="removeItem" />
    </template>
  </GenericList>
</template>

<script>
import DataHeader from './DataHeader.vue';
import DataItem from './DataItem.vue';
import GenericList from '../generic/GenericList.vue';

export default {
  components: {
    DataHeader,
    DataItem,
    GenericList,
  },
  methods: {
    removeItem(item) {
      if (this.$refs.GenericList) {
        this.$refs.GenericList.removeItem(item);
      }
    },
  },
};
</script>
